import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { UpdateTimeOffPolicyPayload } from '../types';

export function useUpdateTimeOffPolicy() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('timeOff');
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: UpdateTimeOffPolicyPayload) => timeOffService.updatePolicy(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.policy(orgId) });
      toast.success({ title: t('settings.toasts.policySaved') });
    },
  });
}
